/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useHistory } from 'react-router-dom' // Npm: React router dom.
import { HiChartPie, HiPencil } from 'react-icons/hi2' // Npm: React icons.
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@chakra-ui/react' // Npm: Chakra UI components.


/*
 * OBJECTS
 */
const Index = ({
  customerId,
  companyName,
  currency,
  PassOnUpdate,
  ActiveCustomerSet
}) => {
  // Hook assignment.
  const _historyRef = useHistory()

  // Return component.
  return (
    <Menu placement='left'>
      <MenuButton
        as={Button}
        margin='auto'
        borderRadius='8px'
        color='gray.500'
        bg='transparent'>
        <HiPencil size={18} />
      </MenuButton>
      <MenuList
        className='dropDownMenu'
        maxHeight='400px'
        overflow='auto'>
        <MenuItem
          gap='12px'
          display='flex'
          pl='20px'
          pr='20px'
          color='gray.500'
          onClick={() => {
            // Execute handler.
            PassOnUpdate({ customerId, companyName, currency })
            ActiveCustomerSet({ customerId, companyName, currency }) //  set active customer in store for details report page.
            // Push customer id to url.
            _historyRef.push(`/reports/customer/margin`)
          }}
          minH='40px'>
          <HiChartPie size={18} />
          <span>Details Report</span>
        </MenuItem>
      </MenuList>
    </Menu>
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'currency': PropTypes.string,
  'customerId': PropTypes.string,
  'companyName': PropTypes.string,
  'PassOnUpdate': PropTypes.func,
  'ActiveCustomerSet': PropTypes.func
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u }),
  'ActiveCustomerSet': u => __dispatch({ 'type': 'ACTIVE_CUSTOMER_SET', 'ActiveCustomer': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
